import { Component, OnInit, Input } from '@angular/core';
import { Paginator } from 'src/app/models/paginator';

@Component({
  selector: 'app-paginator-footer',
  templateUrl: './paginator-footer.component.html',
  styleUrls: ['./paginator-footer.component.css']
})
export class PaginatorFooterComponent implements OnInit {

  @Input()paginator:Paginator;

  constructor() { }

  ngOnInit(): void {
  }

}
